/* Copyright Levelise Ltd 2026 */
import { createContext, useCallback, useState } from 'react';

/**
 * Holds the Orders route's selection and lists above the router, so that following a facility link
 * out of /orders and coming back leaves the page as it was. OrdersRoute unmounts on navigation, so
 * this state cannot live in it.
 */
const defaultValue = {
	companies: [],
	selectedCompany: null,
	orders: [],
	facilities: [],

	setCompanies: () => {},
	setSelectedCompany: () => {},
	setOrders: () => {},
	setFacilities: () => {},
	clearState: () => {},
};

const OrdersContext = createContext(defaultValue);

export default OrdersContext;

export function OrdersProvider({ children }) {
	const [companies, setCompanies] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [orders, setOrders] = useState([]);
	const [facilities, setFacilities] = useState([]);

	const clearState = useCallback(() => {
		setCompanies([]);
		setSelectedCompany(null);
		setOrders([]);
		setFacilities([]);
	}, []);

	return (
		<OrdersContext.Provider
			value={{
				companies,
				selectedCompany,
				orders,
				facilities,

				setCompanies,
				setSelectedCompany,
				setOrders,
				setFacilities,
				clearState,
			}}
		>
			{children}
		</OrdersContext.Provider>
	);
}
